import moment from 'moment';
import firebase from './firebase';
import db from './db';

function getBusinessMonthFunction() {
    // 取得當下時間
    const now = moment();
    const originalCurrentTime = {
        year: now.format('YYYY'),
        month: now.format('MM'),
        date: now.format('DD')
    };
    // 檢查本日是否已經是16號之後（含16號）
    let hasPassedFifteen = parseInt(originalCurrentTime.date) >= 16 ? true : false;
    // 預設營業月份
    let businessMonth = '';
    if (hasPassedFifteen && originalCurrentTime.month !== '12') {
        // 如果已經超過15號，且當月月份不是12月
        // 將營業月份算為下個月份
        let m = `${parseInt(originalCurrentTime.month) + 1}`;
        // 如果下個月份的字數小於兩個字
        if (m.length < 2) {
            // 就在前面補個0
            m = `0${m}`;
        }
        businessMonth = `${originalCurrentTime.year}${m}`;
    } else if (hasPassedFifteen && originalCurrentTime.month === '12') {
        // 如果已經超過15號，且當月月份是12月
        // 將營業月份算為明年的一月
        businessMonth = `${parseInt(originalCurrentTime.year) + 1}${'01'}`;
    } else if (!hasPassedFifteen) {
        // 如果營業月份未超過15號
        // 將營業月份算為本月月份
        businessMonth = `${originalCurrentTime.year}${originalCurrentTime.month}`;
    }
    return businessMonth;
}

function getBusinessMonthListFunction(m) {
    const currentBusinessMonth = getBusinessMonthFunction();
    const format = 'YYYYMM';
    const count = m ? m : 6;
    let month = moment(currentBusinessMonth, format);
    const monthList = [];
    for (let i = 0; i < count; i++) {
        const monthLabel = month.format('YYYY/MM');
        const monthValue = month.format(format);
        monthList.push({
            label: monthLabel,
            value: monthValue
        })
        month = month.subtract(1, 'month');
    }
    return monthList;
}

function getQualificationKeyFunction(qualification) {
    const businessMonth = getBusinessMonth();
    // 營業月份 >= changemonth 取 current
    // 營業月份 < changemonth 取 before
    let qualificationKey;
    if (parseInt(businessMonth) >= parseInt(qualification.CHANGEMONTH)) {
        qualificationKey = qualification['CURRENT'];
    } else {
        qualificationKey = qualification['BEFORE'];
    }
    return qualificationKey;
}

function getCurrentJPNSEQFunction() {
    return window.localStorage.getItem('FordaysJPNSEQ');
}

async function getCurrentUserFunction(JPNSEQ) {
    const businessMonth = getBusinessMonthFunction();
    let currentUser = firebase.auth().currentUser;
    const uid = currentUser.uid;
    // 取得使用者登入時的JPNSEQ
    const currentJPNSEQ = JPNSEQ || window.localStorage.getItem('FordaysJPNSEQ');
    if (currentUser) {
        // 取得符合JPNSEQ的使用者文件集合
        const customerDocs = await db
            .collection(`jcustomerout`)
            .where('JPNSEQ', '==', parseInt(currentJPNSEQ))
            .get();
        // 使用者
        let user = {
            email: currentUser.email,
            uid: currentUser.uid,
            displayName: currentUser.displayName,
            emailVerified: currentUser.emailVerified
        }
        // 取得文件集合中的第一筆資料並設定為目前使用者資訊
        customerDocs.forEach(doc => {
            const data = doc.data();
            // user = {
            //     ...user,
            //     ...data
            // }
            user = {
                ...user,
                SEQ: data.SEQ,
                JPNSEQ: data.JPNSEQ,
                name: data.NAME,
                phs: data.PHS,
                registDate: data.REGISTDATE,
                cName: data.CNAME,
                dispatch: data.DISPATCH,
                docSend: data.DOCSEND,
                eName: data.ENAME,
                // offDate: data.OFFDATE,
                PDIV: data.PDIV,
                uid: uid
            }
            return;
        });
        // 取得該使用者資格文件集合
        const qualificationsDocs = await db
            .collection('jqualificationout')
            .where('SEQ', '==', user.SEQ)
            .get();
        // 設定資格文件
        let qualification;
        // 以第一筆資料作為使用者資格文件
        qualificationsDocs.forEach(doc => {
            qualification = doc.data();
            // 如果CHANGEMONTH是null
            if (qualification.CHANGEMONTH === null) {
                // 預設為0
                qualification.CHANGEMONTH = 0;
            }
            return;
        });
        // 取得當月資格key
        let qualificationKey = getQualificationKeyFunction(qualification);
        // 取得資格對照表
        const qualificationTypeDoc = await db
            .doc(`jqualificationtypeout/${qualificationKey}`)
            .get();
        // 設定使用者資格
        user.qualificationType = qualificationTypeDoc.data().NAME;
        const JC2MapDoc = await db.doc(`JC2map_masterOut/${user.SEQ}${businessMonth}`).get();
        user.ACT = JC2MapDoc.exists ? JC2MapDoc.data().ACT : 0;
        // 回傳整理後的使用者
        return user;
    } else {
        return null;
    }
}

async function getUserAliasListFunction(email) {
    const aliasList = [];
    const docs = await db.collection('jcustomerout')
        .where('EMAIL', '==', email)
        .get()
    docs.forEach(doc => {
        const alias = doc.data();
        aliasList.push(alias);
    });
    return aliasList;
}

async function getCurrentUserDefaultAddressFunction(user) {
    const docSend = user.docSend;
    const doc = await db.doc(`jaddressmasterout/${docSend}`).get();
    const address = doc.data();
    return address;
}

async function getHierarchyFunction(user, businessMonth) {
    const result = {
        exists: false,
        data: {}
    };
    const doc = await db
        // 從JC2map_masterOut集合取得
        .collection('JC2map_masterOut')
        // 一名為SEQ+搜尋營業月份的文件
        .doc(`${user.SEQ}${businessMonth}`)
        .get();
    // 如果文件不存在
    if (!doc.exists) {
        // 直接回傳內容
        return result;
    }
    // 如果文件存在
    // 放入資料
    result.exists = true;
    result.data = doc.data();
    // 回傳結果
    return result
}

async function getUserCourseFunction(user, businessMonth) {
    const qualificationDoc = await db
        .collection('jqualificationout')
        .doc(user.SEQ)
        .get();

    const qualification = qualificationDoc.data();
    if (qualification.CHANGEMONTH === null) {
        // 預設為0
        qualification.CHANGEMONTH = 0;
    }
    let COURSE;
    if (parseInt(businessMonth) >= parseInt(qualification.CHANGEMONTH)) {
        COURSE = qualification['CURRENT'];
    } else {
        COURSE = qualification['BEFORE'];
    }
    return COURSE;
}

async function getUserRegularSellsetsFunction(user, businessMonth) {
    const COURSE = await getUserCourseFunction(user, businessMonth);
    user.COURSE = COURSE;
    const sellSetDocs = await db
        .collection('jsellsetout')
        .where('COURSE', '==', COURSE)
        .get();

    // 所有該使用者的ItemCodes
    const allItemCodes = []
    sellSetDocs.forEach(sellSetDoc => {
        const sellSet = sellSetDoc.data();
        if (sellSet.ENABLED !== 1) {
            return;
        }
        // 如果allItemCodes尚未紀錄此筆ITEMCODE
        if (!allItemCodes.includes(sellSet.ITEMCODE)) {
            // 記錄此itemCode
            allItemCodes.push(sellSet.ITEMCODE);
        }
    });

    const itemsPromise = allItemCodes.map(itemCode => {
        return db
            .collection('jitemout')
            .doc(itemCode)
            .get();
    });

    // 取得到所有ITEM的文件
    const itemDocs = await Promise.all(itemsPromise);
    // ITEM查詢集合表
    const items = {}
    itemDocs.forEach(itemDoc => {
        const item = itemDoc.data();
        const id = itemDoc.id;
        items[id] = item;
    });

    const allSets = {};
    /*
        格式：
        {
            // SETCODE 1
            1: {
                // SEQUENCE 1
                1: []
                // SEQUENCE 2
                2: []
                // SEQUENCE 3
                3: []
            },
            // SETCODE 2
            2: {
                // SEQUENCE 1
                1: []
                // SEQUENCE 2
                2: []
                // SEQUENCE 3
                3: []
            },
        }
    */
    sellSetDocs.forEach(sellSetDoc => {
        const sellSet = sellSetDoc.data();
        if (sellSet.ENABLED !== 1) {
            return;
        }
        const SETCODE = sellSet.SETCODE;
        const SEQUENCE = sellSet.SEQUENCE;
        // 如果allSets物件尚未紀錄此筆SETCODE
        if (!(SETCODE in allSets)) {
            // 預設該Setcode為空物件
            allSets[SETCODE] = {}
        }
        // 如果該SEQUENCE尚未記錄於SETCODE內
        if (!(SEQUENCE in allSets[SETCODE])) {
            // 預設該SEQUENCE為空陣列
            allSets[SETCODE][SEQUENCE] = [];
        }
        // 查詢到商品詳細資料
        const item = items[sellSet.ITEMCODE];
        // 補上商品詳細資料
        sellSet.data = item;
        // 把資料推入
        allSets[SETCODE][SEQUENCE].push(sellSet);
    });
    return allSets;
}

async function getUserAdditionalSellsetsFunction(vm, user, businessMonth) {
    const COURSE = await getUserCourseFunction(user, businessMonth);
    user.COURSE = COURSE;
    const SEQ = user.SEQ;
    return vm.axios
        // FIXME: 待測試階段完成受修正為正式API
        .post(`https://fordays-backend-official.herokuapp.com/member/jselladdout`, { SEQ })
        .then(async (jselladdoutRes) => {
            const sellSetDocs = jselladdoutRes.data.Value;
            const allItemCodes = []
            sellSetDocs.forEach(sellSet => {
                if (sellSet.BUYABLE !== 1) {
                    return;
                }
                // 如果allItemCodes尚未紀錄此筆ITEMCODE
                if (!allItemCodes.includes(sellSet.ITEMCODE)) {
                    // 記錄此itemCode
                    allItemCodes.push(sellSet.ITEMCODE);
                }
            });

            const itemsPromise = allItemCodes.map(itemCode => {
                return db
                    .collection('jitemout')
                    .doc(itemCode)
                    .get();
            });

            // 取得到所有ITEM的文件
            const itemDocs = await Promise.all(itemsPromise);
            // ITEM查詢集合表
            const items = {}
            itemDocs.forEach(itemDoc => {
                const item = itemDoc.data();
                const id = itemDoc.id;
                items[id] = item;
            });

            const allSets = [];

            sellSetDocs.forEach(sellSet => {
                if (sellSet.BUYABLE !== 1) {
                    return;
                }
                // 查詢到商品詳細資料
                const item = items[sellSet.ITEMCODE];
                // 補上商品詳細資料
                sellSet.data = item;
                // 非贈品
                sellSet.SAMPLEFLG = 0;
                // 把資料推入
                allSets.push(sellSet);
            });
            return allSets;
        })
        .catch(err => {
            console.log('[取得加購失敗]', err);
            alert('[發生錯誤]取得加購資訊失敗。');
        })
}


export const getBusinessMonth = getBusinessMonthFunction;
export const getBusinessMonthList = getBusinessMonthListFunction;
export const getQualificationKey = getQualificationKeyFunction;
export const getCurrentJPNSEQ = getCurrentJPNSEQFunction;
export const getCurrentUser = getCurrentUserFunction;
export const getUserAliasList = getUserAliasListFunction;
export const getHierarchy = getHierarchyFunction;
export const getUserCourse = getUserCourseFunction;
export const getUserRegularSellsets = getUserRegularSellsetsFunction;
export const getUserAdditionalSellsets = getUserAdditionalSellsetsFunction;
export const getCurrentUserDefaultAddress = getCurrentUserDefaultAddressFunction;
export const getNumberWithCommas = (x) => {
    if (!x) {
        return '0';
    }
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export const hideId = (str) => {
    if (!str) {
        return str;
    }
    const arr = str.split('');
    for (let i = 3; i <= 7; i++) {
        arr[i] = '*';
    }
    const replacedStr = arr.join('');
    return replacedStr;
}
